const getNodeChild = (index, node) => {
  return node.children[index]
}

export default getNodeChild
